/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize TFGDeterioration View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './TFGDeteriorationView';

export const mapStateToPropsTFGDeterioration = mapStateToProps;
export const mapDispatchToPropsTFGDeterioration = mapDispatchToProps;

export default connect(
  mapStateToPropsTFGDeterioration,
  mapDispatchToPropsTFGDeterioration
)(View);
